import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Descriptions as AntdDescriptions, Row } from "antd";

import PageDetails from "../../general/details";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import Image from "../../general/antd/image";

import BeneficiaryGroupContext from "../../../context/beneficiary-groups/context";
import BeneficiaryGroupContextProvider from "../../../context/beneficiary-groups/provider";

const Details = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { details, actions, loading } = useContext(BeneficiaryGroupContext);

  useEffect(() => {
    id && actions.getDetails(Number(id));
  }, [id]);

  return (
    <PageDetails
      title={`${t("details")}`}
      subtitle={t("beneficiary_group")}
      buttonName={t("edit")}
      onClick={() => navigate(`/beneficiary-groups/update/${id}`)}
    >
      {loading.includes("details") ? (
        <Spin />
      ) : (
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <Descriptions size="small" column={1} bordered>
              <AntdDescriptions.Item label={t("id")}>
                {details?.id}
              </AntdDescriptions.Item>

              <AntdDescriptions.Item label={t("name")}>
                {details?.name ?? "-"}
              </AntdDescriptions.Item>

              <AntdDescriptions.Item label={t("image")}>
                <Image src={details?.image?.url} preview />
              </AntdDescriptions.Item>

              {/* <AntdDescriptions.Item label={t("created_by")}>
                {details?.created_by ?? "-"}
              </AntdDescriptions.Item>

              <AntdDescriptions.Item label={t("updated_by")}>
                {details?.updated_by ?? "-"}
              </AntdDescriptions.Item>

              <AntdDescriptions.Item label={t("created_at")}>
                {details?.created_at
                  ? new Date(details.created_at).toLocaleString()
                  : "-"}
              </AntdDescriptions.Item>

              <AntdDescriptions.Item label={t("updated_at")}>
                {details?.updated_at
                  ? new Date(details.updated_at).toLocaleString()
                  : "-"}
              </AntdDescriptions.Item> */}
            </Descriptions>
          </Col>
        </Row>
      )}
    </PageDetails>
  );
};

const BeneficiaryGroupDetailsPage = () => {
  return (
    <BeneficiaryGroupContextProvider>
      <Details />
    </BeneficiaryGroupContextProvider>
  );
};

export default BeneficiaryGroupDetailsPage;
